import React, { useCallback, useEffect, useRef } from 'react';
import {  DeletePopupWrapper,  PopupWrapper } from './ViewCompetitive.styled';
import DateSlider from '../../Common/DateSlider/dateSlider';
import { RedCrossIcon } from '../../Common/SvgIcon/CommonSvgIcons';
import { useState } from 'react';
import PopUp from '../../Common/PopUp/PopUp';
import Button from '../../Common/Button/Button';
import styled from 'styled-components';
import MyDatePicker from '../../components/DatePicker/DatePicker';
import { formatDateFilter } from '../../utils';
import TitleWithInfo from '../../Common/TitleWithInfo/TitleWithInfo';
import { DateFilterDiv, DateFilterSharedDiv, DateFilterSubWrapper,  SelectTopicWrapper, ShowTopicWrapper } from './SelectChannelPage.style';
import PrimaryTopicComponent from './PrimaryTopicComponent';
import SelectedTopic from './SelectedTopic';
import { useDispatch, useSelector } from 'react-redux';
import { getRecentCiReports, getSecondaryCiList, searchReports, setSearchVal, setSecondaryEmpty } from '../../store/redux/slices/competitiveIntelligenceSlice';
import { debounce } from 'lodash';
import DoubleDateSlider from '../../Common/DateSlider/DoubleDateSlider';


const SelectChannelPage = ({

    setSlectValid1,
    setSlectValid2,
    selectValid2,
    selectValid1,
    setChecked,
    checked,
    topicOneError = false,
    topicTwoError = false,
    topicCount,topicOptions,
    selectedTopicOne, setSelectedTopicOne,
    startDateOne,
    endDateOne,
    onDateSliderChange,
    dateHandler,
    setStartDateOne,
    setEndDateOne,
    channelType,
    setSelectedDateRanges, selectedDateRanges,
    formatValue = 'dd/mm/yyyy',
    topicOne,
    topicTwo,
    setTopicOne,
    setTopicTwo, setTopicTwoError, setTopicOneError
}) => {
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false)
    const [expandPrimary, setExpandPrimary] = useState(false);
    const [expandSecondary, setExpandSecondary] = useState(false);
    const [topicOneChange, setTopicOneChange] = useState('');
    const [loading, setLoading] = useState(false)
    const [difDate, setDifDate] = useState();

    const { searchReportData, searchVal, secondaryCiList } = useSelector((state) => state.competitiveIntelligence) || [];
    const debouncedSearchRef = useRef(null);

    // Define the debouncedSearch function inside a useEffect to ensure it's created once
    useEffect(() => {
        // Initialize the debounced function only once
        debouncedSearchRef.current = debounce((inputValue) => {

            // Start loading here to indicate that the search is in progress
            setLoading(true);

            // Dispatch the search report action with the input value as the query
            dispatch(searchReports({
                "is_topic": channelType == 'Social Topics' ? true : false,
                query: inputValue  // Send the actual input as the query
            }))
                .then(() => setLoading(false))  // Stop loading once the search is completed
                .catch(() => setLoading(false));  // Stop loading in case of an error
        }, 500);  // 500ms debounce delay

        // Cleanup the debounced function on unmount
        return () => {
            if (debouncedSearchRef.current) {
                debouncedSearchRef.current.cancel();  // Cancel any pending debounced search when the component unmounts
            }
        };
    }, [dispatch, channelType]);  // This runs only once when the component mounts



    const onChangeSearch = (inputValue) => {
        setLoading(true); // Start loading when the user begins typing
        dispatch(setSearchVal(inputValue)); // Update the search value in your Redux store
        // debouncedSearch(inputValue);  // Call the debounced function with the current input
        debouncedSearchRef.current(inputValue);
    };


    const { ciRecentData } = useSelector((state) => state.competitiveIntelligence) || [];
    function parseDate(dateString) {
        const parts = dateString?.split(/[-/]/);
        if (parts?.length === 3) {
            const day = parts?.length === 3 && parts[0]?.length === 2 ? parts[0] : parts[1];
            const month = parts?.length === 3 && parts[0]?.length === 2 ? parts[1] : parts[0];
            const year = parts[parts?.length - 1];
            return new Date(year, month - 1, day);
        }
        return null;
    }

    function getIntersection(start1, end1, start2, end2, isactive = false) {

        // Convert date strings to Date objects
        const startDate1 = parseDate(start1);
        const endDate1 = parseDate(end1);
        const startDate2 = parseDate(start2);
        const endDate2 = parseDate(end2);

        if (!startDate1 || !endDate1 || !startDate2 || !endDate2) {
            return "Invalid date format.";
        }

        // Find the later start date
        const intersectionStart = new Date(Math.max(startDate1.getTime(), startDate2.getTime()));

        // Find the earlier end date
        const intersectionEnd = new Date(Math.min(endDate1.getTime(), endDate2.getTime()));

        // Check if there is an intersection
        let endVal1;
        if (isactive == true) {
            endVal1 = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
            return {
                start: intersectionStart.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }),
                end: endVal1,
            };
        }
        if (intersectionStart <= intersectionEnd) {
            let endVal;
            if (isactive == true) {
                endVal = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
            } else {
                endVal = intersectionEnd.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }
            return {
                start: intersectionStart.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }),
                end: endVal,
            };
        } else {
            return "No intersection"; // No overlap
        }
    }

    function getNonItersection(start1, end1, start2, end2) {
        const dates = [start1, end1, start2, end2];
        const parsedDates = dates.map(dateStr => {
            const [day, month, year] = dateStr.split("/");
            return new Date(`${year}-${month}-${day}`);
        });

        const [date1, date2, date3, date4] = parsedDates;
        const minDate = new Date(Math.min(...parsedDates));
        const maxDate = new Date(Math.max(...parsedDates));

        const diffTime = Math.abs(maxDate - minDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const getDiffInDays = (date) => Math.ceil((date - minDate) / (1000 * 60 * 60 * 24));

        // Logic for handling identical start and end dates
        let sliderStartDate = `${minDate.getFullYear()}, ${minDate.getMonth()}, ${minDate.getDate()}`;
        let axisVal2 = diffDays + 1;
        let minVal1 = getDiffInDays(date1) + 1;
        let maxVal1 = getDiffInDays(date2) + 1;
        let minVal2 = getDiffInDays(date3) + 1;
        let maxVal2 = getDiffInDays(date4) + 1;

        // Check if start1 == start2 and end1 == end2 (same range)
        if (start1 === start2 && end1 === end2) {
            // Calculate midpoint between start1/end1 and start2/end2
            const midpoint = new Date((date1.getTime() + date2.getTime()) / 2);

            const midpointDiff = Math.ceil((midpoint - minDate) / (1000 * 60 * 60 * 24));


            // Split the period into two halves
            minVal1 = 1;
            maxVal1 = midpointDiff;
            minVal2 = midpointDiff + 1;
            maxVal2 = diffDays + 1;
        }


        return {
            sliderStartDate,
            axisVal2,
            minVal1,
            maxVal1,
            minVal2,
            maxVal2,
        };
    }


    useEffect(() => {
        console.log("selectedTopicOne updated:", selectedTopicOne);
    }, [selectedTopicOne]);

    const handleRemovePopup = (val) => {
        if (val == 'topic1') {
            setTopicOneChange('topic1')
        } else {
            setTopicOneChange('topic2')
        }
        setShowPopup(true)
    }
    const handleClosePopup = () => {
        setShowPopup(false)
    }
    const handleRemove = () => {
        if (topicOneChange == 'topic1') {
            setTopicOne()

            setTopicTwo()
            dispatch(setSecondaryEmpty());
        } else {
            setTopicTwo()
        }
        setShowPopup(false)
        setSelectedTopicOne(null)
    }
    const handleSelectTopic = ({ val, type }) => {
        setSlectValid1(false)
        setSlectValid2(false)
        if (type == 'Primary') {
            setTopicOneError(false)
            setTopicOne(val);
            dispatch(getSecondaryCiList({
                "is_topic": channelType == 'Social Topics' ? true : false,
                "job_id": val?.job_id
            }));
            setExpandPrimary(false)
            if (!val?.start_date || !val?.end_date) {
                if (!val?.start_date || !val?.end_date) {
                    setSlectValid1(true)
                }

            }
            if (topicTwo) {
                let common = getIntersection(val?.start_date, val?.end_date, topicTwo?.start_date, topicTwo?.end_date, val?.is_active == 0 && topicTwo?.is_active == 0 ? true : false);


                if (common?.start && common?.end) {
                    setSelectedTopicOne({
                        start_date: common.start,
                        end_date: common.end,
                    });
                } else {
                    // Handle the case where there is no intersection
                    setSelectedTopicOne(null); // Or set a default value
                }
            }
        } else {
            setTopicTwoError(false)
            setTopicTwo(val);
            setExpandSecondary(false);
            let common = getIntersection(topicOne?.start_date, topicOne?.end_date, val?.start_date, val?.end_date, (topicOne?.is_active == 0 && val?.is_active == 0) ? true : false);

            // setSelectedTopicOne({
            //         start_date: common?.start,
            //         end_date: common?.end,

            //     })
            if (checked && common?.start && common?.end) {

                setSelectedTopicOne({
                    start_date: common.start,
                    end_date: common.end,
                });
            } else {
                setSelectedTopicOne(null); // Or set a default value
                if (!topicOne?.start_date || !topicOne?.end_date || !val?.start_date || !val?.end_date) {
                    if (!topicOne?.start_date || !topicOne?.end_date) {
                        setSlectValid1(true)
                    }
                    if (!val?.start_date || !val?.end_date) {
                        setSlectValid2(true)
                    }
                } else if (topicOne?.job_id != val?.job_id) {
                    let nonCommon = getNonItersection(topicOne?.start_date, topicOne?.end_date, val?.start_date, val?.end_date);

                    setDifDate(nonCommon);
                } else {
                    let nonCommon = getNonItersection(topicOne?.start_date, topicOne?.end_date, val?.start_date, val?.end_date);

                    setDifDate(nonCommon);
                }
            }

        }
    }
    

    useEffect(() => {
        dispatch(getRecentCiReports(channelType == 'Social Topics' ? true : false))
        dispatch(searchReports({
            "is_topic": channelType == 'Social Topics' ? true : false,
            query: ''  // Send the actual input as the query
        }))
        dispatch(setSecondaryEmpty())
    }, [channelType])
    return (
        <div>

            <SelectTopicWrapper>
                <PrimaryTopicComponent
                    setExpandPrimary={setExpandPrimary}
                    expandPrimary={expandPrimary}
                    mainLabelVal={channelType == 'Social Topics' ? 'Primary Topic' : 'Primary Chatter'}
                    subLabelVal={`Select an active ${channelType == 'Social Topics' ? 'topic' : 'chatter'} you want to evaluate or compare.`}
                    PlaceHolderVal={`Search preferred ${channelType == 'Social Topics' ? 'topic' : 'chatter'}`}
                    topicTitle={topicOne ? (topicOne?.title || topicOne?.chatter_title) : `Search preferred ${channelType == 'Social Topics' ? 'topic' : 'chatter'}`}
                    RecentlyCreatedVal={`Recently created ${channelType == 'Social Topics' ? 'topic' : 'chatter'}`}
                    topicOptions={ciRecentData}
                    handleSelect={handleSelectTopic}
                    channelType={channelType}
                    value={searchVal}
                    searchLoader={loading}
                    onChangeSearch={onChangeSearch}
                    type={'Primary'}
                    seachTopic={searchReportData}
                    checked={checked}
                    setChecked={setChecked}
                    topicError={topicOneError}
                />

                <PrimaryTopicComponent
                    checked={checked}
                    setChecked={setChecked}
                    isSecondary={true}
                    setExpandPrimary={setExpandSecondary}
                    expandPrimary={expandSecondary}
                    channelType={channelType}
                    mainLabelVal={`Secondary ${channelType == 'Social Topics' ? 'Topic' : 'chatter'}`}
                    subLabelVal={`Select a ${channelType == 'Social Topics' ? 'topic' : 'chatter'} to benchmark and analyze against your primary topic.`}
                    PlaceHolderVal={`Select comparative ${channelType == 'Social Topics' ? 'topic' : 'chatter'}`}
                    RecentlyCreatedVal={`${channelType == 'Social Topics' ? 'Topics' : 'Chatters'} which can be compared`}
                    topicOptions={topicOptions}
                    secondaryCiList={secondaryCiList}
                    handleSelect={handleSelectTopic}
                    topicTitle={topicTwo ? (topicTwo?.title || topicTwo?.chatter_title) : `Select comparative ${channelType == 'Social Topics' ? 'topic' : 'chatter'}`}
                    type={'Secondary'}
                    topicError={topicTwoError}
                />


            </SelectTopicWrapper>
            {
                (topicOne || topicTwo) &&

                <ShowTopicWrapper>

                    <SelectedTopic
                        topic={topicOne}
                        topicTitle={`${channelType == 'Social Topics' ? 'Topic' : 'Chatter'}`}
                        handleRemovePopup={handleRemovePopup}
                        val={'topic1'}
                        selectValid={selectValid1}
                    />
                    <div>vs</div>
                    <SelectedTopic
                        topic={topicTwo}
                        topicTitle={"Compare with"}
                        handleRemovePopup={handleRemovePopup}
                        val={'topic2'}
                        selectValid={selectValid2}
                    />
                </ShowTopicWrapper>
            }
            {
                topicOne && topicTwo && topicOne?.start_date && topicTwo?.start_date && topicTwo?.end_date && topicOne?.start_date &&

                <div style={{ display: (topicOne && topicTwo && !checked) ? true : (topicOne && topicTwo && selectedTopicOne !== null) ? true : 'none' }}
                >
                    {
                        topicOne && topicTwo && !checked ? <TitleWithInfo title={checked ? 'Shared Time Interval' : 'Independent Time Interval '} infoText={checked ? 'Adjust the slider to analyze comparative insights on the shared time window between topics.' : `Set unique time intervals for each topic to enable comparative analysis across distinct periods.`} />
                            :
                            topicOne && topicTwo && selectedTopicOne !== null && <TitleWithInfo title={checked ? 'Shared Time Interval' : 'Independent Time Interval '} infoText={checked ? 'Adjust the slider to analyze comparative insights on the shared time window between topics.' : `Set unique time intervals for each topic to enable comparative analysis across distinct periods.`} />
                    }
                    <DateFilterSubWrapper >
                        {
                            selectedTopicOne !== null && checked ?


                                <DateFilterSharedDiv>
                                    {/* <div><div>{topicOne?.title || ''}</div></div> */}
                                    <div>
                                        <div style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '500',
                                            fontSize: '14px',
                                            color: 'rgba(99, 99, 99, 0.7)',
                                            // marginBottom: '6px'
                                        }}>Overlap Begins</div>
                                        <MyDatePicker
                                            name="firstPostDate"
                                            value={formatDateFilter(startDateOne) || formatDateFilter(selectedTopicOne?.start_date) || ''}
                                            dateHandler={dateHandler}
                                            format={
                                                formatValue
                                            }
                                            readOnlyvalue={true}
                                            min={formatDateFilter(topicOne?.start_date)}
                                            max={formatDateFilter(topicOne?.end_date)}
                                            width={"83%"}
                                            color={true}
                                            style={{
                                                border: "1px solid rgba(217, 217, 217, 1)",
                                                boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                borderRadius: '6px',
                                                padding: '0px 10px',
                                                minHeight: '35px'

                                            }}
                                        />
                                    </div>

                                    <div>
                                        <div style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '500',

                                            fontSize: '14px',
                                            color: 'rgba(99, 99, 99, 0.7)',
                                            // marginBottom: '6px'

                                        }}>Overlap Ends</div>
                                        <MyDatePicker
                                            name="firstPostDate"
                                            value={formatDateFilter(endDateOne) || formatDateFilter(selectedTopicOne?.end_date) || ''}
                                            dateHandler={dateHandler}
                                            format={
                                                formatValue
                                            }
                                            readOnlyvalue={true}
                                            min={formatDateFilter(topicTwo?.start_date)}
                                            max={formatDateFilter(topicTwo?.end_date)}
                                            width={"83%"}
                                            color={true}
                                            style={{
                                                border: "1px solid rgba(217, 217, 217, 1)",
                                                boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                borderRadius: '6px',
                                                padding: '0px 10px',
                                                minHeight: '35px'

                                            }}
                                        />
                                    </div>
                                </DateFilterSharedDiv>

                                :
                                !checked ?
                                    <div>

                                        <DateFilterDiv>
                                            <div><div>{topicOne?.title || ''}</div></div>
                                            <div>
                                                <div style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    color: 'rgba(99, 99, 99, 0.7)',
                                                    marginBottom: '6px'
                                                }}>Start Date</div>
                                                <MyDatePicker
                                                    name="firstPostDate"
                                                    value={formatDateFilter(selectedDateRanges?.track1?.start) || formatDateFilter(topicOne?.start_date)}
                                                    dateHandler={dateHandler}
                                                    format={
                                                        formatValue
                                                    }
                                                    readOnlyvalue={true}
                                                    min={formatDateFilter(topicOne?.start_date)}
                                                    max={formatDateFilter(topicOne?.end_date)}
                                                    width={"83%"}
                                                    color={true}
                                                    style={{
                                                        border: "1px solid rgba(217, 217, 217, 1)",
                                                        boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                        borderRadius: '6px',
                                                        padding: '0px 10px',
                                                        minHeight: '35px'

                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <div style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '500',

                                                    fontSize: '14px',
                                                    color: 'rgba(99, 99, 99, 0.7)',
                                                    marginBottom: '6px'

                                                }}>End Date</div>
                                                <MyDatePicker
                                                    name="firstPostDate"
                                                    value={formatDateFilter(selectedDateRanges?.track1?.end) || formatDateFilter(topicOne?.end_date)}
                                                    dateHandler={dateHandler}
                                                    format={
                                                        formatValue
                                                    }
                                                    readOnlyvalue={true}
                                                    min={formatDateFilter(topicTwo?.start_date)}
                                                    max={formatDateFilter(topicTwo?.end_date)}
                                                    width={"83%"}
                                                    color={true}
                                                    style={{
                                                        border: "1px solid rgba(217, 217, 217, 1)",
                                                        boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                        borderRadius: '6px',
                                                        padding: '0px 10px',
                                                        minHeight: '35px'

                                                    }}
                                                />
                                            </div>
                                        </DateFilterDiv>

                                        <DateFilterDiv>
                                            <div><div>{topicTwo?.title || ''}</div></div>
                                            <div>
                                                <div style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '500',

                                                    fontSize: '14px',
                                                    color: 'rgba(99, 99, 99, 0.7)',
                                                    marginBottom: '6px'

                                                }}>Start Date</div>
                                                <MyDatePicker
                                                    name="firstPostDate"
                                                    value={formatDateFilter(selectedDateRanges?.track2?.start) || formatDateFilter(topicTwo?.start_date)}
                                                    dateHandler={dateHandler}
                                                    format={
                                                        formatValue
                                                    }
                                                    readOnlyvalue={true}
                                                    min={formatDateFilter(topicOne?.start_date)}
                                                    max={formatDateFilter(topicOne?.end_date)}
                                                    width={"83%"}
                                                    color={true}
                                                    style={{
                                                        border: "1px solid rgba(217, 217, 217, 1)",
                                                        boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                        borderRadius: '6px',
                                                        padding: '0px 10px',
                                                        minHeight: '35px'

                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <div style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '500',

                                                    fontSize: '14px',
                                                    color: 'rgba(99, 99, 99, 0.7)',
                                                    marginBottom: '6px'

                                                }}>End Date</div>
                                                <MyDatePicker
                                                    name="firstPostDate"
                                                    value={formatDateFilter(selectedDateRanges?.track2?.end) || formatDateFilter(topicTwo?.end_date)}
                                                    dateHandler={dateHandler}
                                                    format={
                                                        formatValue
                                                    }
                                                    readOnlyvalue={true}
                                                    min={formatDateFilter(topicOne?.start_date)}
                                                    max={formatDateFilter(topicOne?.end_date)}
                                                    width={"83%"}
                                                    color={true}
                                                    style={{
                                                        border: "1px solid rgba(217, 217, 217, 1)",
                                                        boxShadow: " 0px 0px 8px 0px rgba(162, 162, 162, 0.24)",
                                                        borderRadius: '6px',
                                                        padding: '0px 10px',
                                                        minHeight: '35px'

                                                    }}
                                                />
                                            </div>
                                        </DateFilterDiv>

                                    </div>
                                    :
                                    <></>
                        }
                        <div>
                            {
                                topicOne && topicTwo && !checked ?
                                    <DoubleDateSlider {...difDate}
                                        topicOne={topicOne} topicTwo={topicTwo}

                                        sameTopic={topicOne?.job_id == topicTwo?.job_id ? true : false}
                                        onThumbChange={(data) => {
                                            setSelectedDateRanges(data); // Save to state
                                            // You can do things like setDateRange(data), update state, etc.
                                        }} />
                                    :
                                    topicOne && topicTwo && selectedTopicOne !== null &&

                                    <DateSlider
                                        startDate={selectedTopicOne?.start_date}
                                        endDate={selectedTopicOne?.end_date}
                                        // progress={{ start: 20, end: 60 }}
                                        onChange={onDateSliderChange}
                                        topicCount={topicCount}
                                        setStartDateOne={setStartDateOne}
                                        setEndDateOne={setEndDateOne}
                                        is_active={topicOne?.is_active == 0 && topicTwo?.is_active == 0 ? true : false}
                                    />
                            }
                        </div>
                    </DateFilterSubWrapper>
                </div>

            }
            {
                showPopup &&

                <PopUp onClose={() => handleClosePopup()}>
                    <PopupWrapper>

                        <DeletePopupWrapper>
                            <p>{RedCrossIcon}</p>
                            <p style={{ color: 'red', fontSize: '16px', fontWeight: '600' }}>Remove Topic</p>
                            <p>Are you sure you want to remove Topic ?</p>
                            <div style={{ width: '550px', marginTop: '70px', justifyContent: 'center' }}>
                                <Button
                                    style={{ minWidth: '160px', background: 'white' }}
                                    onClick={handleClosePopup}
                                    value={'Cancel'} />
                                <Button
                                    data-testid="handleRemove"
                                    onClick={() => handleRemove()}
                                    value={'Remove'} />
                            </div>
                        </DeletePopupWrapper>
                    </PopupWrapper>
                </PopUp>
            }
        </div>
    );
};
export default SelectChannelPage;